import { createSlice } from "@reduxjs/toolkit"

export const initialState = {
    isAdding: false,
    isAdded: false,
    error: null,
    isUpdating: false,
    isUpdated: false,
}
export const appSlice = createSlice({
    name: "addToCartReducer",
    initialState: initialState,
    reducers: {
        addToCartInitiate: (state) => {
            state.isAdding = true
            state.isAdded = false
        },
        addToCartSuccess: (state) => {
            state.isAdding = false
            state.isAdded = true
        },
        addToCartFailure: (state, action) => {
            state.error = action.payload
            state.isAdding = false
        },
        updateCartInitiate: (state) => {
            state.isUpdating = true
            state.isUpdated = false
        },
        updateCartSuccess: (state) => {
            state.isUpdating = false
            state.isUpdated = true
        },
        updateCartFailure: (state, action) => {
            state.error = action.payload
            state.isUpdating = false
        },
    },
})

export default appSlice.reducer
export const {
    addToCartInitiate,
    addToCartSuccess,
    addToCartFailure,
    updateCartInitiate,
    updateCartSuccess,
    updateCartFailure,
} = appSlice.actions
